import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DoneIcon } from 'common/icons';
import { DateCell } from 'common/components';
import classNames from 'classnames';
import { withTheme } from 'common/styling/theme';
import { staticStyles, getDynamicStyles } from './style';

const PaymentStatus = ({ event, isLastEvent, statusGroup, theme }) => {
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;
  return (
    <div
      className={classNames('PaymentStatus', {
        [`PaymentStatus-${statusGroup?.color || 'processing'}`]: isLastEvent,
        'PaymentStatus-new': event.newEvent,
        'PaymentStatus-existing': !event.newEvent,
      })}>
      <div className="PaymentStatus-icon">{isLastEvent ? statusGroup?.icon || <DoneIcon /> : <DoneIcon />}</div>
      <div className="PaymentStatus-info">
        {statusGroup?.title ? (
          <FormattedMessage id={statusGroup?.title}>
            {txt => <p className="PaymentStatus-info-title">{txt}</p>}
          </FormattedMessage>
        ) : (
          <p className="PaymentStatus-info-title">{event.status}</p>
        )}
        <DateCell value={event.updated} inLine grey />
      </div>

      <style jsx global>
        {staticStyles}
      </style>
      <style jsx>{dynamicStyles}</style>
    </div>
  );
};

PaymentStatus.propTypes = {
  event: PropTypes.object.isRequired,
  isLastEvent: PropTypes.bool.isRequired,
  statusGroup: PropTypes.object.isRequired,
  theme: PropTypes.object,
};

PaymentStatus.defaultProps = {
  theme: {},
};

PaymentStatus.defaultProps = {};

export default withTheme()(PaymentStatus);
export { PaymentStatus };
